import { useSelector } from 'react-redux';
import { selectLegacyCartId } from './checkout-router-selectors';
import { useLegacyCheckoutForm } from './use-legacy-checkout-form';
import { usePaymentMapper } from './use-payment-mapper';
import type { PurchaseMutationVariables } from '../../../__generated__/graphql';
import type { EmvTransaction } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';

export const useCheckoutMapper = () => {
  const getForm = useLegacyCheckoutForm(); // TODO replace by useContext when/during redux-form migration
  const cartId = useSelector(selectLegacyCartId); // TODO replace selector when modern reserve is released (or useContext)
  const mapPayment = usePaymentMapper();

  const mapToPurchaseRequest = (emvTransaction?: EmvTransaction): PurchaseMutationVariables => {
    if (!cartId) {
      // TODO error handling in next MR
      throw new Error('missing cart id');
    }
    const form = getForm();
    const payment = mapPayment(form, emvTransaction);

    return {
      cartId,
      customer: {
        name: form.fullName,
        email: form.email,
        phone: {
          number: form.phoneNumber,
          prefix: form.phonePre.name,
        },
      },
      payment,
      note: form.paymentNode ?? '',
      linkGlobalAccount: false,
    };
  };

  const mapToDeliveryRequest = (orderId: string) => {
    throw new Error(`modern delivery not implemented yet - orderId: ${orderId}`);
  };

  return { mapToPurchaseRequest, mapToDeliveryRequest };
};
